import { render } from "./Footer.vue?vue&type=template&id=501e8a4c"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=501e8a4c&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__